import QueryResult from '@/components/QueryResult/query-result';
import { useQuery } from '@apollo/client';
import React from 'react';
import PickServiceContainer from '../PickServiceContainer';
import { SPECIALTIES } from '../queries';
import BookingDateModal from './Modals/BookingDateModal';
import ContactMethodModal from './Modals/ContactMethodModal';
import SpecialtyModal from './Modals/SpecialtyModal';
import './PickServiceMobile.scss';

function PickServiceMobile() {
  const { loading, error, data } = useQuery(SPECIALTIES);

  return (
    <PickServiceContainer styleId="pick-service-mobile">
      <QueryResult loading={loading} error={error} data={data}>
        <SpecialtyModal specialties={data?.specialtiesForHome} />
      </QueryResult>
      <ContactMethodModal />
      <BookingDateModal />
    </PickServiceContainer>
  );
}

export default PickServiceMobile;
